import { useContext } from "react";
import { AppearanceContext } from "../context/AppearanceContext";

const useAppearance = () => {
  return useContext(AppearanceContext);
}

export default useAppearance;
